import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ResetPasscodePage } from './reset-passcode';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    ResetPasscodePage
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(ResetPasscodePage),
  ],
})
export class ResetPasscodeModule {
}



// WEBPACK FOOTER //
// ./src/pages/auth/reset-passcode/reset-passcode.module.ts